<template>
  <div class="internal-only-microsite">
    <div class="center-wrapper">
      <div class="head-color-bar" :style="{ backgroundColor: company.color }"></div>
      <div class="company-logo">
        <img :src="company.logo"/>
      </div>
      <div class="tip-msg">
        <p>{{ $t('error.page.internalOnlyMicroSite.message.notEmployee', { companyName }) }}</p>
        <p>{{ $t('error.page.internalOnlyMicroSite.message.onlyInternal') }}</p>
        <p v-if="inactive">
          {{ $t('error.page.internalOnlyMicroSite.message.toRegister.inactive') }}
        </p>
        <p v-else>
          {{ $t('error.page.internalOnlyMicroSite.message.toRegister.prefix', { companyName }) }}
          <a class="link" :href="redirectUrl">
            {{ $t('error.page.internalOnlyMicroSite.message.toRegister.content') }}
          </a>
          {{ $t('error.page.internalOnlyMicroSite.message.toRegister.suffix', { companyName }) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      redirectUrl: null,
      siteData: {}
    }
  },
  computed: {
    siteId () {
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    company () {
      return this.siteData.company || {}
    },
    companyName () {
      const isEn = this.$i18n.locale === 'en'
      return isEn ? this.company.name : this.company.cn_name
    },
    inactive () {
      return this.$route.query.inactive
    }
  },
  created () {
    this.initSiteData()
  },
  methods: {
    ...mapActions('crm', ['getMicrositeCompanyInfo', 'getMicrositeCampaignCompanyInfo']),
    async initSiteData () {
      this.$eventBus.$emit('showLoading', true)
      try {
        let method = this.getMicrositeCompanyInfo
        if (this.type === 'campaign') {
          method = this.getMicrositeCampaignCompanyInfo
        }
        const resp = await method(this.siteId)
        if (resp) {
          this.siteData = resp
          this.redirectUrl = '/referral/employee-register/?company_id=' + this.company.id
          if (this.type === 'campaign') {
            this.redirectUrl += '&back_url=/recruiting/crm/campaign/' + this.siteId
          } else if (this.type === 'microsite') {
            this.redirectUrl += '&back_url=/microsite/crm/' + this.siteId
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.internal-only-microsite {
  display: flex;
  height: 100vh;
  width: 100vw;
  background: #000;

  .center-wrapper {
    flex: 1;
    margin: 10% 7% auto;
    padding-bottom: 80px;
    background: #fff;

    .head-color-bar {
      height: 15px;
    }

    .company-logo {
      img {
        display: block;
        width: 150px;
        height: 150px;
        margin: 0px auto;
      }
    }

    .tip-msg {
      margin: 10px 20px;
      text-align: center;
    }
  }
}
</style>
